import React, { Component } from 'react';
import '../css/App.css'
import FaCheck from 'react-icons/lib/fa/check'
import { numFormat, setColor, removeSpecialChar} from '../utils/helper'
import Progressbar from './ProgressBar'
    
class OfficeBox extends Component {

    checkActualCandidateExceptWritein = (name) =>{
       let candidate = removeSpecialChar(name).toLowerCase()
       return !candidate.match('writein') 
    }

    checkActualCandidate = (name) => {
       let candidate = removeSpecialChar(name).toLowerCase()
       return (!candidate.match('overvotes') && !candidate.match('undervotes'))
    }

    render(){
        const defaultColor = '#13dcb8'
        const resultdata = this.props.dataList
        const isTop = this.props.topResult
        const colorSet = this.props.colorSet
        const appendPartyCodeToCandidateName = this.props.appendPartyCodeToCandidateName

        return (
             <div className="card" id={resultdata.ContestNumber}>
                <div className="card-header">
                    <p>{resultdata.OfficeName} </p>
                </div>
                <div className="card-body">
                    {resultdata.ElectionData && resultdata.ElectionData.filter(datarow => this.checkActualCandidate(datarow.Contestant)).map((datarow, index) => (
                        <div key={datarow.Contestant} className="wrapperStyle mb-4">
                            <div className='leftStyle' style={{position:'relative'}}>
                                {datarow.Contestant + (this.checkActualCandidateExceptWritein(datarow.Contestant) && datarow.PartyCode && appendPartyCodeToCandidateName ? ' - ' + datarow.PartyCode : '')}
                                <span className='float-right mr-3'>{numFormat(datarow.Votes)}</span>
                                <Progressbar style={{position:'absolute',bottom:'0px',width:'100%',height:'10px'}} width={datarow.VotesPercentage} color={(colorSet && colorSet[index])?colorSet[index] : defaultColor}/>
                            </div>
                            <div className='text-center rightStyle' style={{background:( (colorSet && colorSet[index]) ? colorSet[index] : defaultColor)}}>
                                <p style={{fontWeight:'bold',fontSize:'20px', position:'relative', top:11}}>{datarow.VotesPercentage}
                                    <span style={{fontSize:12}}>%</span>
                                </p></div>
                        </div>
                    ))}
                    {resultdata.ElectionData && resultdata.ElectionData.filter(datarow => !this.checkActualCandidate(datarow.Contestant)).map((datarow, index) => (
                        <div key={datarow.Contestant} >
                            <span style={{fontSize:'14px', width:'150px', display:'inline-block'}}>{datarow.Contestant}</span>
                            <span style={{fontSize:'14px'}}>{numFormat(datarow.Votes)}</span>
                        </div>
                    ))}
                </div>
            </div>
              

               
        )
    }
}

export default OfficeBox



// WEBPACK FOOTER //
// ./src/components/OfficeBox.js